/**
 * Resolve the user shown in the top-bar / sidebar (name + logout control).
 *
 * The MSAL `user` (AccountInfo) is null for native (password) sessions, so gating the
 * logout button on it alone hid logout for native logins. We fall back to the current
 * app user (resolved from the session cookie, available for BOTH auth methods) so the
 * name and logout control always render when authenticated.
 */
export interface DisplayUser {
  name?: string | null;
  username?: string | null;
}

interface MsalAccountLike {
  name?: string | null;
  username?: string | null;
}

interface CurrentUserLike {
  name: string;
  email: string;
}

export function resolveDisplayUser(
  msalUser: MsalAccountLike | null | undefined,
  currentUser: CurrentUserLike | null | undefined,
): DisplayUser | null {
  if (msalUser) return msalUser;
  if (currentUser) return { name: currentUser.name, username: currentUser.email };
  return null;
}
